import * as React from 'react';

export interface SidebarContextValue {
  isToggle: boolean;
  setToggle(isToggle: SidebarContextValue['isToggle']): void;
}

export const SidebarContext
  = React.createContext<Partial<SidebarContextValue>>({});

export default SidebarContext;
